import callPhoneNumber from '$tablet-app/src/app/phone/callPhoneNumber';
import { deviceContacts } from '$tablet-app/src/app/utils/deviceContacts';

interface CallContactParams {
  /** The contact being called */
  name: string;

  /** The phone number to call */
  number: string;
}

/**
 * Calls the given phone number using device contacts.
 * Checks for a contact with existing number and creates one if one does not exist
 * */
export const callNumberWithPhoneContact = async ({
  name,
  number,
}: CallContactParams): Promise<void> => {
  const existingContacts = await deviceContacts.getContactByPhoneNumber(number);
  if (existingContacts.length === 0) {
    await deviceContacts.addContact({ name, number });
  }
  callPhoneNumber(number);
};
